import { render, staticRenderFns } from "./uploads-file.vue?vue&type=template&id=25e9b23b&scoped=true"
import script from "./uploads-file.vue?vue&type=script&lang=js"
export * from "./uploads-file.vue?vue&type=script&lang=js"
import style0 from "./uploads-file.vue?vue&type=style&index=0&id=25e9b23b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e9b23b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25e9b23b')) {
      api.createRecord('25e9b23b', component.options)
    } else {
      api.reload('25e9b23b', component.options)
    }
    module.hot.accept("./uploads-file.vue?vue&type=template&id=25e9b23b&scoped=true", function () {
      api.rerender('25e9b23b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user/uploads-file.vue"
export default component.exports